module.exports = __webpack_public_path__ + "static/img/fenxiao.89108a67.png";